export default {
  meta: {
    title: '相关定义'
  }
};
